import { forwardRef, HTMLProps, ChangeEvent } from 'react';

import FontIcon from 'components/icons';

import './styles/select.scss';

type Props = Omit<HTMLProps<HTMLSelectElement>, 'as' | 'onChange'> & {
  hasError?: boolean
  noBorder?: true
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  placeholder?: string //non-standard, custom prop
}

const SelectField = forwardRef<HTMLSelectElement, Props>(
  function SelectField(props, ref) {
    const { children, className, noBorder, hasError, placeholder, ...rest } = props;

    return (
      <div className="select-container">
        <select
          { ...rest }
          ref={ ref }
          className={ `form-field--select ${className ?? ''} ${!!hasError ? 'input-has-error' : ''} ${!!noBorder ? 'has-no-borders' : ''} ` }
        >
          {placeholder && <option value="" disabled hidden>{placeholder}</option>}
          {children}
        </select>
        <FontIcon className="wiw-select-down-arrow" icon="chevron-down" />
      </div>
    );
  }
);

export default SelectField;
